import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import { Builder } from '@src/routes/content/components/builder'
import { DaysBuilder } from '@src/routes/content/components/training-plan-builder/days-builder'
import { Icon } from '@src/elements/icon/icon'
import { TrainingPlanName } from '@src/routes/content/components/training-plan-builder/training-plan-name'
import { TrainingPlanComposition } from '@src/routes/content/components/training-plan-builder/training-plan-composition'
import { TrainingPlanService } from '@src/service/training-plan'
import { LoadingScreen } from '@src/components/loading-screen/loading-screen/loading-screen'

import './training-plan-viewer.sass'

@Component
export class TrainingPlanViewer extends Vue {

  private service: TrainingPlanService = new TrainingPlanService()
  private loading = true

  created () {
    this.loadPlan()
  }

  loadPlan () {
    if (this.$route.params.id) {
      let planId = parseInt(this.$route.params.id, 10)
      return this.service.getTrainingPlanWithDays(planId)
        .then(trainingPlan => this.$store.dispatch('setSelectedTrainingPlan', { trainingPlan }))
        .catch(async error => {
          console.error('failed to retrieve training plan', error)
          return this.$store.dispatch('removeNewTrainingPlan')
        })
        .finally(() => this.loading = false)
    }
  }

  render (h: CreateElement) {
    return this.loading ? <LoadingScreen/> : <Builder cssClass='training-plan-viewer'>
      <TrainingPlanName slot={'topLeft'} disabled={true} />

      <div onClick={this.exit} slot='close'><Icon name='util/close-circled' /></div>

      <DaysBuilder slot={'builder'} disableEdit={true}/>

      <TrainingPlanComposition slot={'composition'} />
    </Builder>
  }

  exit () {
    this.$router.go(-1)
  }
}
